import { Injectable } from '@angular/core';
import { EmployeeApiService } from '@api-services/employee-api.service';
import { Employee } from '@app/models/employee.model';
import { EmployeeAppointmentSortOrderEnum } from '@app/models/EmployeeAppointmentSortOrderEnum';
import { Service } from '@app/models/service.model';
import { SiteBookingSettings } from '@app/models/siteBookingSettings.model';
import { LocalStorageService, SITE_BOOKING_SETTINGS } from './local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class EmployeeService {
    constructor(
        private employeeApiService: EmployeeApiService,
        private localStorageService: LocalStorageService
    ) {}

    public getEmployeeList(employeeIDList?: string[], serviceIDList?: string[]) {
        return this.employeeApiService.getEmployeeList(employeeIDList, serviceIDList);
    }

    public getEmployeesFromServiceList(serviceList: Service[]) {
        if (!serviceList.length) {
            return [];
        }
        let commonEmployeeIds: Set<string> = new Set(serviceList[0].employeeIDList);

        for (let i = 1; i < serviceList.length; i++) {
            commonEmployeeIds = new Set(serviceList[i].employeeIDList?.filter((id) => commonEmployeeIds.has(id)));
        }
        return Array.from(commonEmployeeIds);
    }

    public getEmployeeServicePriceListForFirstAvailability(serviceIdList: string[]) {
        const employeeServicePrice = [];
        for (const serviceId of serviceIdList) {
            employeeServicePrice.push({
                serviceID: serviceId,
                price: 0,
            });
        }
        return employeeServicePrice;
    }

    public sortEmployeeList(employeeList: Employee[], localeId?: string): Employee[] {
        const siteBookingSettings = this.localStorageService.get(SITE_BOOKING_SETTINGS) as SiteBookingSettings;
        const sortByWebOrder = siteBookingSettings?.employeeAppointmentSortOrder === EmployeeAppointmentSortOrderEnum.WebsiteOrder;

        if (sortByWebOrder) {
            const withWebOrder = employeeList
                .filter((e) => e.webOrder !== undefined && e.webOrder !== null)
                .sort((a, b) => {
                    const webOrderDiff = (a.webOrder ?? 0) - (b.webOrder ?? 0);
                    return webOrderDiff !== 0 ? webOrderDiff : a.name.localeCompare(b.name, localeId);
                });
            const withoutWebOrder = employeeList
                .filter((e) => e.webOrder === undefined || e.webOrder === null)
                .sort((a, b) => a.name.localeCompare(b.name, localeId));
            return [...withWebOrder, ...withoutWebOrder];
        }
        return employeeList.sort((a, b) => a.name.localeCompare(b.name, localeId));
    }
}
